import { PendingReferralsModel } from "one-card-pending-referrals";

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Pending Referal component
 * @param response is the raw json data returned from API.
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let preferrals: PendingReferralsModel = {};
    let tabdata: any = []
    let otherCount: number = 0;
    let pendingCount: number = 0;
    let closedCount: number = 0;
    let authCount: number = 0;
    let note:string = "";
    let authDate: any = [];
    let erroredOut: boolean = false;
    preferrals["erroredOut"] = erroredOut;
    let result: any = {
        referrals: preferrals,
        error: undefined

    }
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error = response;
        preferrals["erroredOut"] = true;
    }
    else if (response && response.length > 0) {
        response.forEach((ele: any) => {
            if (ele?.Status) {
                if (ele.Status === "Pending" || ele.Status === "Pending Review") {
                    pendingCount = pendingCount + 1;
                    let startdate = {
                        referraldate: new Date(ele?.AuthorizationStartDate).toLocaleDateString('en-us',{month:'short', day: 'numeric'})
                    }
                    authDate.push(startdate);
                    note = `Last Referral: ${authDate[0].referraldate}, ${ele?.ReferredByProviderName}`;
                }
                else if (ele.Status === "Closed") {
                    closedCount = closedCount + 1;
                }
                else if (ele.Status === "Authorized") {
                    authCount = authCount + 1;
                } else {
                    otherCount = otherCount + 1;
                }
            }
            let info = {
                referalid: ele?.ExternalReferralNumber,
                referredby: ele?.ReferredByProviderName,
                referredto: ele?.ReferredToProviderName,
                referraltype: ele?.Type,
                referralstatus: ele?.Status
            }
            tabdata.push(info)
        });
    }

    preferrals['pendingreferals'] = pendingCount;
    preferrals['closedreferrals'] = closedCount;
    // preferrals['chartdata'] = [
    //     { id: 's1', label: 'Closed', value: closedCount },
    //     { id: 's2', label: 'Authorized', value: authCount },
    //     { id: 's3', label: 'Pending', value: pendingCount },
    //     { id: 's4', label: 'Other', value: otherCount },
    // ];
    preferrals['chartdata'] = {
                labels: ["Closed", "Authorized", "Pending", "Other"],
                datasets: [{
                    data: [closedCount,authCount,pendingCount,otherCount],
                    backgroundColor: ['#7982B9', '#A5C1DC', '#E9F6FA', '#6050DC'],
                }]
            }
    preferrals["referalsdata"] = tabdata;
    preferrals["note"] = note;
    result.referrals = preferrals;
    return result;
}